import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false
import excel from 'vue-excel-export'
import swal from 'sweetalert2'

const Toast = swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', swal.stopTimer)
        toast.addEventListener('mouseleave', swal.resumeTimer)
    }
});
window.toast = Toast;
// import 'sweetalert2/src/sweetalert2.scss'
window.swal = swal;
import {Form, HasError, AlertError} from 'vform';

window.Form = Form;
Vue.use(excel);
import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true
})
Vue.mixin({
    methods: {
        split2(str, delim) {
            var parts = str.split(delim);
            return [parts[0], parts.splice(1, parts.length).join(delim)];
        },
    },
});
import {Chart} from 'chart.js'
import Chartkick from 'vue-chartkick'
Vue.use(Chartkick);

import moment from "moment-timezone";

window.moment = moment;
Vue.moment = moment;

Vue.filter('filterDate', function (myDate) {
    return moment(myDate).format('Do MMMM YYYY, h:mm:ss a');
});

Vue.filter('filterDateOnly', function (myDate) {
    return moment(myDate).format('dddd, MMMM D, YYYY');
});
Vue.filter('filterTime', function (myDate) {
    return moment(myDate).format('hh:mm:ss a');
});


Vue.filter('filterHumanDate', function (myDate) {
    return moment(myDate).format('Do MMMM YYYY, H:mm:ss');
});
Vue.filter('filterStDate', function (myDate) {
    return moment(myDate).format('DD.MM.YY,hh:mm');
});
new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
